// extracted by mini-css-extract-plugin
export default {"root":"CompareModeNavButton_root__BzHxZ"};